exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".number-btn[data-v-ebd45cf2]{border-radius:30px;position:relative;padding:15px 5px;min-width:80px;text-align:center;color:#000;border:1px solid #ddd;background-color:#fff;font-weight:700;font-size:20px;width:100%;margin:0 0 10px;height:100px}.reportHeadInfo[data-v-ebd45cf2]{font-size:14px;text-align:center;width:100%;background:#00a0f0;color:#fff;padding:5px;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ebd45cf2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/retailSale/retailSale.vue
// module id = 363
// module chunks = 0